export default __webpack_public_path__ + "static/media/total_leads.1a4316c3.svg";